import TextLink from "../components/TextLink";
import MobileFooter from '../components/MobileFooter';

import { motion, AnimatePresence } from "framer-motion"
import { useEffect, useState, useRef } from 'react';
import calculateFeatures from "../lib/calculateFeatures";

function Thumbnail(props) {
    return (
        <div className="column is-6">
            <img onClick={props.onClick} alt={`Screen capture of token ${props.details.id}`} className="image is-dthumb" src={`img/thumb_${parseFloat(props.details.id)-286000000}.jpg`} />
            <p className="is-uppercase">⬤ {props.data.stats.mintlabel} {props.details.id}<br />⬤ Palette {props.details.Palette}</p>
        </div>
    )
}

function Crawler(props) {   
    const iframeRef = useRef();
    const [modalPlayerVisible, setModalPlayerVisible] = useState(false); 
    const [modalPlayerData, setModalPlayerData] = useState({tokenId:0, hash:""}); 
    const showModalPlayer = (id) => {
      let currentVideo =  props.data.tokensData.find(e => e.id == id);
      setModalPlayerData({
        id: currentVideo.id,
        hash: currentVideo.hash
      });
      setModalPlayerVisible(true);
    }
    const hideModalPlayer = () => {
      setModalPlayerData({tokenId:0, hash:""});
      setModalPlayerVisible(false);
    }

    useEffect(()=> {
      if (modalPlayerVisible) {
        
        let height = window.innerHeight;
        let width = window.innerWidth;
        if (width>768) {
          height *= 0.9;
          width = height*0.7;
        }
        iframeRef.current.style.height = height  + "px";
        iframeRef.current.style.width = width + "px";

       
        
      }
    },[modalPlayerVisible])
    
    useEffect(() => {   
      const handleKeyPress = (e) => {
        if (e.keyCode === 27) { hideModalPlayer() }
      }   
      window.addEventListener('keydown', handleKeyPress);
      return () => {
        window.removeEventListener('keydown', handleKeyPress);
      };
    }, []);

    const prepareUrl = (hash) => {
      let pwd = (()=>{
          let x = "0123456789abcdef", hash = '0x'
          for (let i = 4; i > 0; --i) { hash += x[Math.floor(Math.random()*x.length)]}
          return hash
      })();
      return `&hash=${hash + pwd}`;
  }


    // remeber that section should have a has-text-right
    return (
      <>
        <AnimatePresence>
          {modalPlayerVisible && (
            <motion.div className={`modal ${modalPlayerVisible && "is-active"}`} id="modalplayer" {...props.framer.fade}>
              <div className="modal-background" onClick={hideModalPlayer}></div>
              <div className="modal-content">
                  {modalPlayerData.tokenId !== 0 && (
                    <iframe
                      ref={iframeRef}
                      src={`player/?fullscreen=true&id=${modalPlayerData.id}`}
                      title="Drifting video player"
                      width="100%"
                      height="100%">
                    </iframe>)}
              </div>
              <button className="modal-close is-large" aria-label="close" onClick={hideModalPlayer}></button>
            </motion.div>
          )}
        </AnimatePresence>

        <motion.section className="pt-4 pl-4 pb-4 pr-4" {...props.framer.slide}>
          <div className="content is-serif is-size-4">
            <p>
              «The crawler» is a bot that systematically navigates &mdash; <em>drifts</em> &mdash; through the collection and takes screenshots from minted pieces at random time intervals. The last screenshots are visible in this page.
            </p>
            <p className="has-text-centered is-uppercase">
              The crawler
            </p>
            <p>
              This way to explore unexpected sides of the project complements the galleries of <TextLink href="https://www.artblocks.io/project/286">ArtBlocks</TextLink> and <TextLink href="https://opensea.io/collection/drifting-by-simon-de-mai">OpenSea</TextLink>, which I invite to use for a more detailed and complete overview.
            </p>
          </div>
          <div className="columns is-variable is-1 is-multiline is-paddingless is-mobile">
      
              { props.data.crawler.map(e=> {
                let details = props.data.tokensData.find(n=>n.id==e+286000000);
                return (
                  <Thumbnail key={e} details={details} data={props.data} onClick={()=>showModalPlayer(parseFloat(e+286000000))} />
                )
              }) }
          </div>
          {props.mobile&&<MobileFooter {...props} />}
        </motion.section> 
      </>
    )
  }

export default Crawler;
